import React, {useEffect, useState} from "react";
import search from "../assets/search.png";
import add from "../assets/add.png";
import organisations_api from "../api/protected/organisations"
import OrganisationCardContainer from "../containers/OrganisationCardContainer";
import NewOrganisation from "../components/organisations/NewOrganisation";
import {useNavigate, useSearchParams} from "react-router-dom";
import Slider from "../components/Slider";
import info from "../assets/info-icon.png";
import TitleDescriptionPopup from "../components/TitleDescriptionPopup";
import VerifyEmailPopup from "../components/VerifyEmailPopup";
import dashboard_api from "../api/protected/dashboard";
import SubscriptionNeededPopup from "../components/SubscriptionNeededPopup";
import profile_api from "../api/protected/profile";


const Organisations = () => {
    const navigate = useNavigate()
    const [searchParams, setSearchParams] = useSearchParams();
    const [showHidden, setShowHidden] = useState(false);

    const [organisations, setOrganisations] = useState([]);
    const [userOrganisations, setUserOrganisations] = useState([])
    const [demoOrganisations, setDemoOrganisations] = useState([])
    const [showNewOrganisation, setShowNewOrganisation] = useState(false);
    const [searchTerm, setSearchTerm] = useState('')

    const [showTitleHover, setShowTitleHover] = useState(false)
    const titlePopupStyle = {top: 35, left: 250}

    const [subscription, setSubscription] = useState(null);
    const [showSubscriptionPopup, setShowSubscriptionPopup] = useState(false);


    useEffect(() => {
        getOrganisations()
    }, [])

    useEffect(() => {
        if(!userOrganisations || !demoOrganisations) return;
        setOrganisations([...demoOrganisations, ...userOrganisations])
    }, [demoOrganisations, userOrganisations])

    useEffect(() => {
        if (searchParams.get("new") === "1"){
            setShowNewOrganisation(true)
            setSearchParams({});
        };

    })

    const [showVerifyEmailPopup, setShowVerifyEmailPopup] = useState(false);
    useEffect(() => {
        dashboard_api.getValidateEmail().then((response) => {
            const isAlreadyVerified = response.data === 1;

            if (!isAlreadyVerified) {
                setShowVerifyEmailPopup(true)
                console.log("You are not verified. Please click the link in your email.")
            } else {
                setShowVerifyEmailPopup(false)
                console.log("You are verified. Please carry on.")
            }
        })
    }, []);

    const handleEditOrganisation = (organisation) => {
        if (!organisation) return;
        if(organisation.demo) {
            navigate(`/organisations/${organisation.id}?demo=true`)
        } else {
            navigate(`/organisations/${organisation.id}`)
        }
    }

    const updateOrganisationsGrid = () => {
        getOrganisations();
        setShowNewOrganisation(false);
    }

    const getOrganisations = () => {
        let demo_response = organisations_api.getDemoOrganisations();
        demo_response.then(response => {
            setDemoOrganisations(response.data.demo_organisations);
        })
        let response = organisations_api.getOrganisations();
        response.then(response => {
            setUserOrganisations(response.data.organisations);
        })
    }

    const updateToggleHidden = () => {
        setShowHidden(!showHidden);
    }

    const getSubscription = () => {
        let response = profile_api.getSubscription();
        response.then(response => {
            setSubscription(response.data.subscription.type);
        }).catch(() => {});
    };

    useEffect(() => {
        getSubscription();
    }, []);

    const handleNewOrganisationClick = () => {
        const orgCount = userOrganisations.length;

        if (
            (subscription < 1 && orgCount >= 1) ||
            (subscription < 2 && orgCount >= 3)
        ) {
            setShowSubscriptionPopup(true);
            return;
        }

        setShowNewOrganisation(true);
    };

    return (
        <>
            <div className="organisations-page-background-container">
                <div className="organisations-page-container">
                    {showNewOrganisation ?
                        <NewOrganisation updateOrganisationsGrid={updateOrganisationsGrid.bind(this)}/>
                        :
                        <>
                            <div className="organisations-page-header">
                                <div className="page-header-title-container">
                                    <div className="organisations-page-title">
                                        Organisations
                                    </div>
                                    <img src={info} alt="Info"
                                         onMouseOver={() => setShowTitleHover(true)}
                                         onMouseLeave={() => setShowTitleHover(false)}
                                    />
                                </div>
                                {showTitleHover ?
                                    <div className="title-description-popup-container" style={titlePopupStyle}>
                                        <div className="page-title-hover-triangle-outer">
                                            <div className="page-title-hover-triangle-inner"/>
                                        </div>
                                        <div className="title-description-popup-text">Use this page to manage your Organisations.</div>
                                    </div>
                                    : null}
                                <div className="organisations-page-search-container">
                                        <input type="text" placeholder="Search" value={searchTerm}
                                               onChange={(ev) => setSearchTerm(ev.target.value)}
                                               onKeyUp={(ev) => {
                                                    if (ev.key === 'Enter') navigate("/search?term=" + searchTerm)
                                               }}
                                        />
                                        <img src={search} alt="search icon" className="link"/>
                                    </div>
                            </div>
                            <div className="page-actions-container">
                                <div className="page-toggle-hidden">
                                    <Slider update={updateToggleHidden.bind(this)} state={showHidden}/>
                                </div>
                                <div className="toggle-hidden-text">
                                    Show hidden
                                </div>
                                <div className="organisations-page-add-container">
                                    <img src={add} alt="add icon" className="link"
                                         onClick={handleNewOrganisationClick}/>
                                </div>
                            </div>
                            <OrganisationCardContainer organisations={organisations}
                                                  showHidden={showHidden}
                                                  handleClick={handleEditOrganisation.bind(this)} />
                        </>
                    }
                </div>
                {showVerifyEmailPopup && showVerifyEmailPopup ?
                    <VerifyEmailPopup wide={false} /> : null }
                {showSubscriptionPopup && (
                    <SubscriptionNeededPopup
                        onClose={() => setShowSubscriptionPopup(false)}
                        title = "Maximum organisations reached"
                    />
                )}
            </div>
        </>
    )
}

export default Organisations
